// Añade automáticamente el pack de 6 aceites (gratis por descuento automático) por cada humidificador del carrito
(function () {
  var HUMIDIFICADORES = [64920765038969, 64920765006201];
  var ACEITES = 64920764973433;
  var fetchOriginal = window.fetch.bind(window);
  var ocupado = false;

  function enviar(url, datos) {
    return fetchOriginal(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(datos)
    });
  }

  async function sincronizar() {
    if (ocupado) return false;
    ocupado = true;
    try {
      var carrito = await (await fetchOriginal('/cart.js')).json();
      var humidificadores = carrito.items
        .filter(function (i) { return HUMIDIFICADORES.indexOf(i.variant_id) !== -1; })
        .reduce(function (s, i) { return s + i.quantity; }, 0);
      var regalo = carrito.items.find(function (i) {
        return i.variant_id === ACEITES && i.properties && i.properties._regalo;
      });
      var actual = regalo ? regalo.quantity : 0;
      if (actual === humidificadores) return false;
      if (regalo) {
        await enviar('/cart/change.js', { id: regalo.key, quantity: humidificadores });
      } else {
        await enviar('/cart/add.js', {
          items: [{ id: ACEITES, quantity: humidificadores, properties: { _regalo: 'Free with your fireplace' } }]
        });
      }
      return true;
    } catch (e) {
      return false;
    } finally {
      ocupado = false;
    }
  }

  function trasSincronizar(cambiado) {
    if (cambiado && /\/cart\/?$/.test(location.pathname)) location.reload();
  }

  window.fetch = async function (entrada, opciones) {
    var respuesta = await fetchOriginal(entrada, opciones);
    var url = typeof entrada === 'string' ? entrada : (entrada && entrada.url) || '';
    if (/\/cart\/(add|change|update)/.test(url)) sincronizar().then(trasSincronizar);
    return respuesta;
  };

  document.addEventListener('DOMContentLoaded', function () {
    sincronizar().then(trasSincronizar);
  });
})();
